module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cc-Jc.7619609a.png";